import { Button } from '@trwl/shared/ui/button';
import { LogoHorizontalIcon } from '@trwl/shared/ui/icons';
import Link from 'next/link';

export const TelegramReviewsBlock = () => {
  return (
    <section className="w-full grid grid-cols-1 lg:grid-cols-2 items-center justify-around gap-y-[50px]">
      <div className="relative w-full aspect-square">
        <LogoHorizontalIcon
          className={
            'h-[120px] md:h-[180px] lg:h-[180px] absolute top-12 right-[45%]'
          }
          width={undefined}
        />
        <img
          className="absolute z-40 top-0 left-0 w-full px-4"
          src="https://storage.yandexcloud.net/trwl-static/site/tg-iphone-mockup.webp"
          alt="telegramReviewsBlock"
        />
      </div>
      <div
        className={'flex flex-col items-center justify-center gap-6 float-left'}
      >
        <div
          className={
            'text-center font-normal text-md min-[420px]:text-xl leading-7 xl:text-2xl xl:leading-10'
          }
        >
          Исследуйте инновации мировых брендов
          <br />
          вместе с нами – в стильных подборках
          <br />
          нашего Telegram канала
        </div>
        <Button
          as={Link}
          href="https://t.me/trwlstore"
          target="_blank"
          size="lg"
          radius="sm"
          color="primary"
          className="whitespace-nowrap min-w-[250px]"
        >
          Перейти в канал
        </Button>
      </div>
    </section>
  );
};
